import * as React from 'react';

export default class PeriodMarkIcon extends React.PureComponent<{}> {

    public render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="9" fill="white"
                    stroke="#2C3B48" strokeOpacity="0.6" strokeWidth="2" />
                <path d="M4.16602 9.40492L8.92479 14.1668L15.8327 5.8335" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        );
    }
}
